import { render, staticRenderFns } from "./ModalStageDocument.vue?vue&type=template&id=1d6dd8c2&"
import script from "./ModalStageDocument.vue?vue&type=script&lang=js&"
export * from "./ModalStageDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalStageDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports